<div class="balance-chart-tooltip"
    [style.color]="color"
>
    <ng-content></ng-content>
</div>
